import * as React from 'react';

import { ca } from '@cian/analytics';
import { Preloader } from '@cian/components';
import { numberToPrettyString } from '@cian/utils';

import { IVacanciesState, IVacancy } from '../../models/vacancies';

import * as styles from './vacancies.css';

export interface IProps {
  cityId: number;
  cityName: string;
  vacancies: IVacanciesState;
}

const trackClick = (action: string) => {
  ca('event', {
    action: 'vacanciesBlock',
    category: 'main_page',
    label: action,
    name: 'oldevent',
  });
};

export const Vacancies = (props: IProps) => {
  const { cityId, cityName, vacancies } = props;

  if (!vacancies.isFetching && vacancies.data.length < 2) {
    return null as any; // tslint:disable-line:no-any
  }

  return (vacancies.isFetching ? (
    <div className={`cg-container-fluid-xs ${styles['container']} ${styles['center']}`}>
      <Preloader />
    </div>
  ) : (
    <div className={`cg-container-fluid-xs ${styles['container']}`}>
      <a href={'/vacancies/?region=' + cityId} className={styles['link']} onClick={() => trackClick('click_header')}>
        Вакансии {cityName}
      </a>

      <div className={styles['vacancies']}>
        {vacancies.data .map((vacancy: IVacancy) => {
          let { id, company, minSalary, maxSalary, specialization } = vacancy;
          let salary = 'Оплата по договорённости';

          specialization = specialization.length > 44 ? specialization.substr(0, 43) + '…' : specialization;

          switch (true) {
            case (!!minSalary && !!maxSalary):
              salary = `От ${numberToPrettyString(minSalary)} до ${numberToPrettyString(maxSalary)} ₽/мес.`;
            break;

            case (!!minSalary):
              salary = `От ${numberToPrettyString(minSalary)} ₽/мес.`;
            break;

            case (!!maxSalary):
              salary = `До ${numberToPrettyString(maxSalary)} ₽/мес.`;
            break;
          }

          return (
            <div className={styles['vacancy']} key={id}>
              <a
                href={`/vacancies/?region=${cityId}#${id}`}
                className={styles['vacancy_link']}
                onClick={() => trackClick('click_vacancy')}
              >
                <div className={styles['vacancy_title']}>{specialization}</div>

                <div className={styles['vacancy_salary']}>{salary}</div>
              </a>

              <div className={styles['company']}>
                <a href={company.profileUrl} className={styles['company_link']}>
                  {company.avatarUrl &&
                    <img src={company.avatarUrl} alt="" className={styles['company_logo']} />
                  }

                  <ul>
                    <li className={styles['company_name']}>{company.name || `ID: ${company.id}`}</li>

                    {company.age &&
                      <li className={styles['company_age']}>{company.age} на ЦИАН</li>
                    }
                  </ul>
                </a>
              </div>
            </div>
          );
        })}

        <div className={styles['new_vacancy']}>
          <div className={styles['text']}>
            Вы можете опубликовать
            <br />
            вакансию бесплатно
          </div>

          <div>
            <a href="/vacancies/add" className={styles['button']} onClick={() => trackClick('add_vacancy')}>
              + Опубликовать вакансию
            </a>
          </div>
        </div>
      </div>
    </div>
  ));
};
